import Info from 'components/shared/Info'
import Link from 'components/shared/Link'
import Text from 'components/shared/Text'
import { MAINTENANCE_PAGE_LINK } from 'constants/links'
import { FormattedMessage } from 'react-intl'

type CalendarMaintenanceInfoProps = {
    hasDarkMode?: boolean
}

const CalendarMaintenanceInfo = ({
    hasDarkMode,
}: CalendarMaintenanceInfoProps) => {
    const fontVariant = 'bodySmall'

    return (
        <Info
            color="warning"
            variantType="warning"
            hasDarkMode={hasDarkMode}
            {...(hasDarkMode && {
                hasNoBackground: true,
                hasBorder: true,
                borderColor: 'primary_300',
            })}
        >
            <Text
                variant={fontVariant}
                color={hasDarkMode ? 'grayscale_400' : 'grayscale_900'}
            >
                <FormattedMessage
                    id="global.modal.calendar_legend_maintenance"
                    defaultMessage="Niektóre atrakcje będą tymczasowo zamknięte w październiku i listopadzie z powodu prac konserwacyjnych. Przepraszamy za utrudnienia! <link>Sprawdź harmonogram prac</link>"
                    values={{
                        link: (chunks: string[]) => (
                            <Link
                                path={MAINTENANCE_PAGE_LINK}
                                target="_blank"
                                variant={hasDarkMode ? 'primary' : 'secondary'}
                                icon={null}
                                textVariant={fontVariant}
                                data-testid="ticket-calendar-legend-link-maintenance"
                            >
                                {chunks}
                            </Link>
                        ),
                    }}
                />
            </Text>
        </Info>
    )
}

export default CalendarMaintenanceInfo
